import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function queryInitalDataByTenantId(params) {
  return request({
    url: URL.sys.queryInitalDataByTenantId,
    method: 'get',
    params
  })
}

export function createInitalData(data) {
  return request({
    url: URL.sys.createInitalData,
    method: 'post',
    data
  })
}

export function updateInitalData(data) {
  return request({
    url: URL.sys.updateInitalData,
    method: 'post',
    data
  })
}

export function findStandardAll() {
  return request({
    url: URL.sys.findStandardAll,
    method: 'get'
  })
}
